import { MonetizableEnum } from '@ria-client/segment/enums';
import type { FinancialAdvisorsProductCardEntityType } from '@ria-client/supergraph/structuredContent/hydration/FinancialAdvisorsProductCard/types';
import { CtaButton } from '@ria-client/tw-shared-ui';
import { RiaDisclaimer } from '../financial-advisors-summary-table/ria-disclaimer';

export interface CardCtaProps {
  marketplaceEntity: FinancialAdvisorsProductCardEntityType;
  monetizingCtaLabel?: string;
  displayAdLabel?: boolean;
  index?: number;
}

export function CardCta({
  marketplaceEntity,
  monetizingCtaLabel,
  displayAdLabel,
  index = 0,
}: CardCtaProps) {
  const { cta: marketplaceCta, isMonetizing } = marketplaceEntity;
  const cta = {
    link: isMonetizing
      ? marketplaceEntity.applyLink || marketplaceCta.link
      : marketplaceEntity.reviewLink,
    showIcon: isMonetizing,
    subtext: undefined,
    text: isMonetizing ? monetizingCtaLabel || marketplaceCta.text || 'Learn more' : 'Read review',
    type: marketplaceCta.type,
  };
  const annotation =
    marketplaceEntity.ctaAnnotation ||
    (isMonetizing ? `on ${marketplaceEntity.institution.name}'s website` : 'on NerdWallet');

  return (
    <div className="flex w-full flex-col items-center gap-2">
      <CtaButton
        analyticsPayload={{
          index,
          institutionId: marketplaceEntity.institution.id,
          monetizable: marketplaceEntity.monetizable as MonetizableEnum,
          offerId: marketplaceEntity.id,
          productId: marketplaceEntity.product.id,
          productType: marketplaceEntity.productType,
        }}
        cta={cta}
        fullWidth
        size="dense"
      />
      <span className="typography-text-small text-center text-muted-foreground">{annotation}</span>
      {displayAdLabel && marketplaceEntity.isRiaOffer && marketplaceEntity.riaDisclaimerText ? (
        <div className="mt-2">
          <RiaDisclaimer
            monetizable={marketplaceEntity.monetizable as MonetizableEnum}
            riaDisclaimerText={marketplaceEntity.riaDisclaimerText}
          />
        </div>
      ) : null}
    </div>
  );
}
